import React from 'react';
import Contact from '../components/Contact.js';
import SEO from '../components/SEO.js';

const contactSchema = {
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "name": "Contact Vijay Industry",
  "url": "https://vijayindustry.co.in/contact",
  "description": "Contact Vijay Industry in Coimbatore for custom PEB quotes, factory shed inquiries, structural steel engineering, and pricing.",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "Vijay Industry",
    "telephone": "+91-9444833272",
    "email": "vijayindustry.info@gmail.com",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Coimbatore",
      "addressRegion": "Tamil Nadu",
      "addressCountry": "IN"
    }
  }
};

export default function ContactPage() {
  return (
    <div className="page-contact animate-fade-in">
      <SEO 
        title="Contact Vijay Industry | Industrial PEB & Steel Fabrication Quotes"
        description="Get in touch with Vijay Industry in Coimbatore for pre-engineered building quotes, factory shed estimates, roofing inquiries, and custom fabrication prices."
        keywords="Contact Vijay Industry, PEB Quotation Coimbatore, Factory Shed Price Estimate, Steel Fabrication Quotes Tamil Nadu"
        canonical="/contact"
        schemaData={contactSchema}
      />
      {/* Page Header Banner */}
      <div 
        style={{ 
          backgroundColor: 'var(--primary)', 
          color: 'var(--surface)', 
          padding: '4rem 0',
          position: 'relative',
          overflow: 'hidden',
          borderBottom: '4px solid var(--accent)'
        }}
      >
        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <h1 style={{ color: 'var(--surface)', fontSize: '2.5rem', marginBottom: '0.5rem' }}>
            Contact Us
          </h1>
          <p style={{ color: '#94A3B8', maxWidth: '600px', fontSize: '1.1rem' }}>
            Get in touch with our structural engineers today to discuss plans, drawings, and custom fabrication quotes.
          </p>
        </div>
      </div>

      {/* Contact Component */}
      <Contact />
    </div>
  );
}
